module.exports = __webpack_public_path__ + "static/media/document-date.099a345d.png";